<script>
    import { fly } from "svelte/transition";
    import { Badge, Button, Space } from "../index";
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <Space --gap="16px">
            <Badge content="5">
                <Button>按钮</Button>
            </Badge>
            <Badge content="新">
                <Button>按钮</Button>
            </Badge>
            <Badge>
                <Button>按钮</Button>
            </Badge>
        </Space>
        
    </div>
    <h4 class="example-title">带边框</h4>
    <div class="example-body">
        <Badge content="更新啦" bordered>
            <Button color="primary">按钮</Button>
        </Badge>
    </div>
    <h4 class="example-title">独立使用</h4>
    <div class="example-body">
        <Space --gap="16px">
            <Badge content="99+" />
            <Badge content="新消息!" />
        </Space>
    </div>

    <h4 class="example-title">自定义颜色和偏移量</h4>
    <div class="example-body">
        <Badge color="#108ee9" --right="100%" --top="100%">
            <div class="rect" />
        </Badge>
        <Badge color="#87d068" --right="100%">
            <div class="rect" />
        </Badge>
        <Badge>
            <div class="rect" />
        </Badge>
        <Badge color="orange" --top="100%">
            <div class="rect" />
        </Badge>
    </div>
</div>

<style lang="less">
    @import "./example.less";
    .rect {
        background: #eee;
        width: 40px;
        height: 40px;
        display: block;
        border-radius: 8px;
    }
</style>
